<template>
  <div class="content-view pb-2 ">
    <v-row v-for="(field, index) in fields" :key="index" class="ma-0">
      <v-col class="mb-1 label">
        {{ field.fieldName }}
      </v-col>
      <v-col class="mb-1 text">
        {{ field.inputValue }}
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "FieldViewCard",
  props: {
    fields: Array
  }
}
</script>

<style scoped lang="scss">
.content-view {
  max-height: 100%;
  overflow-y: auto;

  .label {
    color: #878787;
    font-size: 16px;
    font-weight: 500;
    line-height: 20px;
    width: 140px;
    flex: 0 0 140px;
  }

  .text {
    font-size: 18px;
    font-weight: 700;
    line-height: 22px;
  }

  .col {
    border-bottom: 1px solid map-get($grey, 'lighten-4');
  }

}
</style>
